<app-menu-bar></app-menu-bar>

<div class="admin-page">
    <div class="admin-container">
        <app-admin-nav></app-admin-nav>

        <div class="toolbar">
            <input class="search" type="text" [(ngModel)]="search" placeholder="Search categories" autocomplete="off" />
            <button class="add-btn" type="button" (click)="openAddModal()">Add category</button>
        </div>

        @if (loading) {
            <p class="state-text">Loading…</p>
        } @else if (categories.length === 0) {
            <p class="state-text">No categories yet.</p>
        } @else if (filteredCategories.length === 0) {
            <p class="state-text">No categories match your search.</p>
        } @else {
            <div class="table-wrap">
                <table class="admin-table">
                    <thead>
                        <tr>
                            <th>Category</th>
                            <th class="actions-col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (c of filteredCategories; track c.id) {
                            <tr>
                                <td>
                                    @if (editingId === c.id) {
                                        <input class="edit-input" type="text" [(ngModel)]="editValue"
                                            (keyup.enter)="saveEdit(c)" />
                                    } @else {
                                        {{ c.categoryName }}
                                    }
                                </td>
                                <td class="actions-col">
                                    @if (editingId === c.id) {
                                        <button type="button" class="link-btn save" (click)="saveEdit(c)">Save</button>
                                        <button type="button" class="link-btn cancel" (click)="cancelEdit()">Cancel</button>
                                    } @else {
                                        <button type="button" class="icon-btn" (click)="startEdit(c)" title="Edit">
                                            <fa-icon [icon]="faPen"></fa-icon>
                                        </button>
                                        <button type="button" class="icon-btn danger" (click)="remove(c)" title="Delete">
                                            <fa-icon [icon]="faTrash"></fa-icon>
                                        </button>
                                    }
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
    </div>
</div>

<app-footer></app-footer>
